import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import createSageMiddleware from 'redux-saga';
import { isDevelopment } from 'vio-libs';
import reducers from './reducers';
import sagas from './sagas';
const development = typeof vaporio !== 'undefined' && isDevelopment(vaporio) || typeof DEVELOPMENT !== 'undefined' && DEVELOPMENT;
const loggerMiddleware = createLogger({
    collapsed: true
});
const sagaMiddleware = createSageMiddleware();
const store = configureStore({
    devTools: development ? {
        features: {
            dispatch: true,
            export: false,
            import: 'custom',
            jump: true,
            lock: true,
            pause: true,
            persist: false,
            reorder: false,
            skip: true,
            test: false
        },
        latency: 1000,
        maxAge: 20,
        name: 'Kinetic Grid Portal',
        serialize: false,
        shouldRecordChanges: true,
        stateSanitizer: state => {
            const modifiedState = Object.assign(Object.assign({}, state), { locations: Object.assign(Object.assign({}, state.locations), { locations: null }), lockers: Object.assign(Object.assign({}, state.lockers), { allLockers: {} }), mapbox: Object.assign(Object.assign({}, state.mapbox), { mapFeatureSources: [] }), metrics: Object.assign(Object.assign({}, state.metrics), { allMetrics: null }) });
            return modifiedState;
        }
    } : false,
    middleware: getDefaultMiddleware => {
        return development ? getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['mapbox/setPreviewFile'],
                ignoredPaths: ['mapbox.previewFile']
            },
            thunk: false
        }).prepend(loggerMiddleware, sagaMiddleware) : getDefaultMiddleware().concat(sagaMiddleware);
    },
    reducer: reducers
});
sagaMiddleware.run(sagas);
export default store;
